import React, { useEffect, useState } from 'react';
import LogoLight from "../../asset/logo_light.png";
import './ProfileSettings.css';

const translations = {
    english: {
        editPassword: 'Edit Password',
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        newPasswordRepeat: 'Repeat New Password',
        submit:'Submit',
           
    },
    german: {
      editPassword: 'Passwort Ändern',
        oldPassword: 'Altes Passwort',
        newPassword: 'Neues Passwort',
        newPasswordRepeat: 'Neues Passwort Wiederholen',
        submit:'Speichern',
      
    },
    czech: {
      editPassword: 'Upravit heslo',
        oldPassword: 'Staré heslo',
        newPassword: 'Nové heslo',
        newPasswordRepeat: 'Opakovat nové heslo',
        submit:'Submit',
       
    },
    italian: {
      editPassword: 'Modifica password',
        oldPassword: 'Vecchia password',
        newPassword: 'Nuova password',
        newPasswordRepeat: 'Ripetere la nuova password',
        submit:'Invia',
     
    },
  };

function ProfilePassword() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [success, setSuccess] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const config=require( '../../config.js');

    const handleSubmit = async (event) => {
        event.preventDefault();
        const user = {
            oldPassword: oldPassword,
            newPassword: newPassword,
        };
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/me/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(user)
            });
            if (response.ok) {
                setSuccess(true);
            } else {
                alert('Failed to change password');
                console.error('Failed to change password');
            }
        } catch (error) {
            alert('Failed to change password');
            console.error('Error updating user:', error);
        }
    };

    useEffect(() => {
        if (success) {
            setNewPassword('');
            setOldPassword('');
            setNewPassword2('');
            alert('Updated successfully');
            setSuccess(false); // Reset success state
        }
    }, [success]);

    return (
        <section className='mt-5'>
            <div>
                <div className="container">
                    <img src={LogoLight} alt='logo' width={300} />
                    <h1 className="text-secondary mt-5">{translations[currentLanguage].editPassword}</h1>
                    <hr />
                    <div className="row">
                        <div className="personal-info my-5">
                            <form className="form-horizontal text-start" role="form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label className="col-lg-3 control-label">{translations[currentLanguage].oldPassword}:</label>
                                    <div className="col-lg-8 mt-2">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <label className="col-lg-3 control-label">{translations[currentLanguage].newPassword}:</label>
                                    <div className="col-lg-8 mt-2">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-group mt-3">
                                    <label className="col-lg-3 control-label">{translations[currentLanguage].newPasswordRepeat}:</label>
                                    <div className="col-lg-8 mt-2">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={newPassword2}
                                            onChange={(e) => setNewPassword2(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="form-group mt-5">
                                    <div className="col mt-2">
                                        <input className="form-control bg-primary text-white" type="submit" value={translations[currentLanguage].submit} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </section>
    );
}

export default ProfilePassword;
